var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 237,
    height: 182,
    viewBox: "0 0 237 182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    fill: "#34353a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 177.4789123535156 181.5 L 59.52108383178711 181.5 L 0.5966351628303528 91 L 59.52111434936523 0.5 L 177.4789123535156 0.5 L 236.4033660888672 91 L 177.4789123535156 181.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "     M 62.79219055175781 4      L 5.193283081054688 91      L 62.79219055175781 178      L 174.2078094482422 178      L 231.8067169189453 91      L 174.2078094482422 4      L 62.79219055175781 4           M 59.25 0      L 177.75 0      L 237 91      L 177.75 182      L 59.25 182      L 0 91      L 59.25 0 Z",
    stroke: "none",
    fill: "#c9a456"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/Polygon.e91e5510401b1fa64a6f5211c067f5b8.svg";
export { ForwardRef as ReactComponent };